/*
 * DRIVLY-UI React Components
 * @license MIT
 */
var e,r=((e=r||{}).Space=" ",e.Enter="Enter",e.Escape="Escape",e.Backspace="Backspace",e.Delete="Delete",e.ArrowLeft="ArrowLeft",e.ArrowUp="ArrowUp",e.ArrowRight="ArrowRight",e.ArrowDown="ArrowDown",e.Home="Home",e.End="End",e.PageUp="PageUp",e.PageDown="PageDown",e.Tab="Tab",e);export{r as Keys};
//# sourceMappingURL=keyboard.js.map
